// react
import React, { useContext,useEffect } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import TextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Select from 'react-select';
import { ValidSelect } from "beaktShared/helpers/validselect";

// services
import { SessionContext } from "beaktShared/services/session";
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1, convertDate, validateDate, MaskDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";
const useStyles = makeStyles(styles);

export default function PagamentoOutros({ pgto, CallloadTotalizadorPgtosOutros, formaOutros, loadCarrinho, history, setalert }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {register, errors, handleSubmit, setValue, clearError, getValues} = useForm({mode: "onBlur"});
  const endPoint = "clientes/";
  
  const [messageReturn, setmessageReturn]= React.useState({
    show:false,
    message:''
  });

  useEffect(() => {
    if (formaOutros.length === 1){  
      handleTipoChange(formaOutros[0].descricao);
    }
  } , []);
  
  const [tipoOutros, settipoOutros] = React.useState(null) 
  const [possuiObservacao, setpossuiObservacao]= React.useState(false);
  const [beaktPix, setbeaktPix] = React.useState(false);
  const [botaoLancarPagamento, setBotaoLancarPagamento] = React.useState(true);
  const [drSim, setDrSim] = React.useState(false);
  const [drSimEtapaSimular, setDrSimEtapaSimular] = React.useState(false);
  const [drSimEtapaRetornoSimulacao, setDrSimEtapaRetornoSimulacao] = React.useState(false);
  const [drSimPlanosParceladosList, setDrSimPlanosParceladosList] = React.useState([]);
  const [drSimPlanoSelecionado, setDrSimPlanoSelecionado] = React.useState(null);
  const [atualizarCliente, setAtualizarCliente] = React.useState(false);
  const [dataPrimeiroVencimento, setDataPrimeiroVencimento] = React.useState(null);
  const [valorFinanciado, setValorFinanciado] = React.useState(null);
  const [confirmacaoAceite, setConfirmacaoAceite] = React.useState(false);
  
  const handleTipoChange = (e) => {
    setbeaktPix(false);
    setpossuiObservacao(false);
    settipoOutros(e);
    setValue("valor", "", false);
    setValue("observacao", "");
    setBotaoLancarPagamento(true);
    setDrSim(false);
    setDrSimEtapaSimular(false);
    setDrSimEtapaRetornoSimulacao(false);
    setDrSimPlanosParceladosList(null);
    setmessageReturn({show:false})
    
    if (e.descricao !== "") 
        clearError("tipo"); 

    // Alterado para exibir campo Observação para todas formas de pagamentos (#112480)
    if (e.ativo === true)
    { 
      setpossuiObservacao(true);
    }
    
    if (e.gateway == "Beakt Pix"){
      setValue("valor", transformValueFloattoFormated(pgto.totalizadorPagamentos.valorPendente), true);
      setbeaktPix(true);
    }
    if (e.descricao === "Venda Financeira"){
      setpossuiObservacao(true);
      setValue("observacao", "Parcelamento em até 48x")
    }
    if (e.descricao === "Dr Sim"){
      setpossuiObservacao(false);
      setBotaoLancarPagamento(false);
      setDrSim(true);
      setDrSimEtapaRetornoSimulacao(false);
      
      if (pgto?.pagamentos?.length > 0)
      {
        setmessageReturn({
          show:true,
          tipo: 'erro',
          message:t('Para pagamentos com a forma selecionada, esta deve ser a primeira forma de pagamento a ser incluída na venda. Após a aprovação do financiamento as demais formas de pagamento poderão ser adicionadas.')
        });
        
        setDrSimEtapaSimular(false);
      }
      else 
      {
        setDrSimEtapaSimular(true);
      }
    }
  };

  const [LoadingForm,setLoadingForm]= React.useState(false);

  const onSubmit = async (data, e) => {
    e.preventDefault();
    setLoadingForm(true);
    let valor = transformValueFormatedtoFloat(data.valor);
    let observacao = data.observacao;

    if(valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2)) {
      setmessageReturn({
        show:true,
        tipo: 'erro',
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return;
    }

    setmessageReturn({show:false});

    // Se for Dr Sim, pede confirmação antes de continuar
    if (tipoOutros.descricao === 'Dr Sim') {
      setalert(
        <SweetAlert
          warning={true}
          title={t('label.attention')}
          showConfirm={true}
          showCancel={true}
          confirmBtnText={t('label.confirm')}
          cancelBtnText={t('button.cancel')}
          cancelBtnBsStyle={"secondary"}
          confirmBtnBsStyle={"danger"}
          onConfirm={() => {
            setalert(null);
            handleConfirmDrSim(data, valor, observacao); 
          }}
          onCancel={() => handleCancelDrSim()}
        >
          <span>
            Você deseja prosseguir com o envio de dados para pedido de financiamento DR SIM? 
          </span>
          {
            (valor < pgto.totalizadorPagamentos.valorPendente.toFixed(2)) &&
            <>
              <br />
              <span>
                Apenas após o retorno de sucesso, você poderá lançar outra forma de pagamento do valor pendente.
              </span>
            </>
          }
        </SweetAlert>
      );
      return;
    }

    // Continua normalmente se não for Dr Sim
    finalizarPagamento(data, valor, observacao, '');
  };

    
  const clearForm = () =>{
    settipoOutros(null);  
    setValue("tipo", "");  
    setValue("valor","");
    setValue("observacao","");
    setpossuiObservacao(false);
  };
  
  const handleSimulaParcelamento = () => {
    if (pgto?.pagamentos?.length > 0)
    {
      setmessageReturn({
        show:true,
        tipo: 'erro',
        message:t('Para pagamentos com a forma selecionada, esta deve ser a primeira forma de pagamento a ser incluída na venda. Após a aprovação do financiamento as demais formas de pagamento poderão ser adicionadas.')
      });
      
      setDrSimEtapaSimular(false);
      return;
    }

    setLoadingForm(true);
    setmessageReturn({show:false});
    setAtualizarCliente(false);
    setDataPrimeiroVencimento(null);
    setValorFinanciado(null);

    const dataValor = getValues('valor');
    const dataDataPrimeiroVencimento = getValues('dataDataPrimeiroVencimento');
    let valor = transformValueFormatedtoFloat(dataValor?.valor);
    let dataPrimeiroVencimento = dataDataPrimeiroVencimento?.dataPrimeiroVencimento;
    
    if (!valor || valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2)) {
      setmessageReturn({
        show:true,
        tipo: 'erro',
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return false;
    }
    
    if (!validateDate(dataPrimeiroVencimento))
    {
      setmessageReturn({
        show:true,
        tipo: 'erro',
        message:t('error_message.invalid_date')
      });    
      setLoadingForm(false);  
      return false;
    }

    setDataPrimeiroVencimento(dataPrimeiroVencimento);
    setValorFinanciado(valor);

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    if (convertDate(dataPrimeiroVencimento) < hoje)
    {
      setmessageReturn({
        show:true,
        tipo: 'erro',
        message: 'Informe uma data maior que a data de hoje.'
      });    
      setLoadingForm(false);  
      return false;
    }
    
    let dataSimulacao = {
        EstabelecimentoId: loadCarrinho.estabelecimentoId,
        Valor: valor,
        ClienteId: loadCarrinho.clienteId,
        DataPrimeiroVencimento: dataPrimeiroVencimento,
    }
    
    // Chama API
    // clienteSimulacaoDrSim
    UsePostApi(endPoint + 'clienteSimulacaoDrSim', dataSimulacao).then(result=> {
      if(result.status !== 200)
      {
        setmessageReturn({
          show:true,
          tipo: 'erro',
          message:t(result.message)
        });                                    
        setLoadingForm(false);  
        return false; 
      }

      const camposObrigatorios = result?.data?.camposObrigatoriosCliente ?? [];
      if (camposObrigatorios.length > 0) {
        const campos = camposObrigatorios.map(c => c.nomeCampo).join(', ');

        setmessageReturn({
          show: true,
          tipo: 'erro',
          message: `Preencha os seguintes campos obrigatórios antes de simular: ${campos}`,
        });
        setAtualizarCliente(true);
        setLoadingForm(false);
        return false;
      }

      const options = result?.data?.simulacaoResponse?.options ?? [];
      if (options.length === 0) {
        setmessageReturn({
          show: true,
          tipo: 'erro',
          message: t('Nenhuma opção de parcelamento foi retornada pela simulação.')
        });
        return false;
      }

      setDrSimPlanosParceladosList(options);
      setDrSimPlanoSelecionado(options[0]);
      setDrSimEtapaSimular(false);
      setDrSimEtapaRetornoSimulacao(true);
      setBotaoLancarPagamento(false);

      setLoadingForm(false);
      return true;    
    });
  };

  const handleNovaSimulacao = () => {
    setDataPrimeiroVencimento(null);
    setValorFinanciado(null);
    setDrSimEtapaSimular(true);
    setDrSimEtapaRetornoSimulacao(false);
    setBotaoLancarPagamento(false);
    setDrSimPlanosParceladosList(null);
    setAtualizarCliente(false);
    setConfirmacaoAceite(false);
    sendScrollToTOP();
  };

  const handleSelecionaPlanoParcelado = (opcaoSelecionada) => {
    setDrSimPlanoSelecionado(opcaoSelecionada);
  };

  const getDataMais30Dias = () => {
    const hoje = new Date();
    hoje.setDate(hoje.getDate() + 30);

    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // mês começa do 0
    const ano = hoje.getFullYear();

    return `${dia}/${mes}/${ano}`;
  };

  const sendScrollToTOP = () => {
      const container = document.querySelector('#divscroll');
      container.scrollTop = 0;
      container.behavior = 'smooth';
  };

  const handleAlterarCliente = () => {
    if (!!history)
      history.push("/adminclinic/identificacaovenda", { origem: "venda" });
  };

  const handleConfirmacaoAceite = (event) => {
    setConfirmacaoAceite(event.target.value === "sim");
    setBotaoLancarPagamento(true);
  };

  const handleCancelDrSim = () => {
    setLoadingForm(false);
    setalert(null);
  };

  const handleConfirmDrSim = async (data, valor, observacao) => {
    let dataPlanoFinanciamento = {
      EstabelecimentoId: loadCarrinho.estabelecimentoId,
      Valor: valor,
      ClienteId: loadCarrinho.clienteId,
      PlanoSelecionado: drSimPlanoSelecionado,
      ItemValorTotal: loadCarrinho?.totalizadorItens?.TotalItensComDesconto,
      DataPrimeiroVencimento: dataPrimeiroVencimento,
    }

    let emprestimoID = '';
    try {
      const result = await UsePostApi(endPoint + 'clienteCriarFinanciamentoDrSim', dataPlanoFinanciamento);

      if(result.status !== 200) {  
        setmessageReturn({
          show:true,
          tipo: 'erro',
          message:t(result.message)
        });                                    
        setLoadingForm(false);  
        return; 
      }

      const emprestimoResponse = result?.data?.emprestimoResponse ?? [];
      emprestimoID = emprestimoResponse?.id;

      setmessageReturn({
        show:true,
        message: (
          <>
            Por favor, clique em <strong>FINALIZAR VENDA</strong> para prosseguir com a análise do empréstimo Dr Sim.
          </>
        )
      });

    } 
    catch (error) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('error_message.api_error')
      });
      setLoadingForm(false);
      return;
    }

    setDrSimEtapaSimular(false);
    setDrSimEtapaRetornoSimulacao(false);
    setBotaoLancarPagamento(false);
    setDrSimPlanosParceladosList(null);
    sendScrollToTOP();

    finalizarPagamento(data, valor, observacao, emprestimoID);
  };

  const finalizarPagamento = (data, valor, observacao, emprestimoID) => {
    let descParcelas = "à vista";
    if(data.parcelas && parseInt(data.parcelas) > 1) {
      let valorParcela = valor / parseInt(data.parcelas);
      descParcelas = data.parcelas + "x "+transformValueFloattoFormated(valorParcela);
    }

    let pg = {
      id: pgto.pagamentos.length + 1,
      tipo: 4,
      descricaoFormaPgto: tipoOutros.descricao,
      gateway: tipoOutros.gateway,
      valor: valor,
      descTipo: tipoOutros.descricao,
      parcela: data.parcelas ?? 1,
      observacao: observacao,
      descPacela: descParcelas,
      orderId: emprestimoID,
    };

    let updatepgto = {
      ...pgto,        
      pagamentos: [
        ...pgto.pagamentos,
        pg
      ]
    };

    clearForm();
    setLoadingForm(false);
    CallloadTotalizadorPgtosOutros(updatepgto);
  };

  return (
    <div>
      
      <form onSubmit={handleSubmit(onSubmit)}>
        {formaOutros.length >= 1 &&
          <GridContainer className={classes.containerin}> 
            <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('sale.type')} *
            </div>
          </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <div className="removeScroll">
              <Select
                styles={ValidSelect(errors.tipo ? true : false)}
                classNamePrefix="select"            
                isSearchable={true}
                name="tipo"
                placeholder={t('label.select')+"..."}
                options={formaOutros}        
                value={tipoOutros != null && formaOutros.filter(({formaPagamentoId}) => formaPagamentoId === tipoOutros.formaPagamentoId)}
                getOptionLabel={({descricao}) => descricao}
                getOptionValue={({formaPagamentoId}) => formaPagamentoId}
                onChange={(value) => handleTipoChange(value)}
                ref={() => register( { name: "tipo" })}
              />
              </div>
              <FormHelperText className={classes.labelRootError}>            
                {errors.tipo && <span className="obg"> {t('label.required')} </span>}
              </FormHelperText> 
            </GridItem>
          </GridContainer>
        }
        <GridContainer className={classes.containerin}> 
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
            {t('label.value')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>  
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue=""  
                  name="valor"               
                  disabled={beaktPix}
                  InputProps={{ inputComponent: MaskMoney}}    
                  inputRef={register({required: true})}
                  error={errors.valor?true:false} 
              />
              <FormHelperText>
                  {errors.valor && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>      
        </GridContainer>
        <GridContainer className={classes.containerin} >
          {
            possuiObservacao &&
            (
              <>
                <GridItem xs={12} sm={3} md={3} style={{marginLeft:'-8px'}}>
                  <div className={classes.labelIdent} >
                    {t('label.observation')}
                  </div><br></br>
                </GridItem>
                <div style={{textAlign:'center'}}>
                  <GridItem xs={12} sm={12} md={12}>  
                    <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      className="inputObs"
                      name="observacao"               
                      inputProps={{maxLength: 100}}                   
                      multiline
                      rows={4}  
                      style={{width:'279px',marginLeft:'7px'}}    
                      inputRef={register({required: false})}
                      error={errors.observacao?true:false} 
                      />
                  </GridItem>
                </div>
              </>
            )
          }
        </GridContainer>

        {
          drSim && (
          <>
            {
              drSimEtapaSimular &&
              <>
                <GridContainer className={classes.containerin}> 
                  <GridItem xs={12} sm={3} md={3}>
                    <div className={classes.labelIdent}>
                      Primeiro Vencimento *
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <TextField
                      error={errors.dataPrimeiroVencimento?true:false}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="dataPrimeiroVencimento"
                      defaultValue={getDataMais30Dias()}
                      InputLabelProps={{shrink: true}}    
                      InputProps={{
                        inputComponent: MaskDate,
                      }}
                    />
                    <FormHelperText>
                      {
                        errors.dataPrimeiroVencimento && 
                        <span className="obg">{t('label.required')}</span>
                      }
                    </FormHelperText>
                  </GridItem>      
                </GridContainer>
              </>
            }
            <div style={{ paddingTop: '25px', textAlign: 'center' }}>
              <hr className='lineGrayDashed' />
              {
                drSimEtapaSimular &&
                <>
                  <GridContainer className={classes.containerin}>
                    <GridItem xs={12} sm={12} md={12}>
                      <Button color="primary" onClick={handleSimulaParcelamento} >
                        {t('button.simulate')}
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      {
                        LoadingForm && 
                        <CircularProgress />
                      }
                    </GridItem>
                    {
                      atualizarCliente &&
                      <GridItem xs={12} sm={12} md={12}>
                        <Button color="sercundary" onClick={handleAlterarCliente} >
                          {t('button.update_client')}
                        </Button>
                      </GridItem>
                    }
                  </GridContainer>
                  <hr className='lineGrayDashed' />
                </>
              }
              {
                drSimEtapaRetornoSimulacao && (
                <>
                  <GridContainer className={classes.containerin}>
                    <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.container}>
                        <h3 className={classes.title}>Escolha uma opção de Parcelamento</h3>
                        <p>Valor financiado: <strong>R$ {transformValueFloattoFormated(valorFinanciado)}</strong></p>
                        <p>Primeiro Vencimento: <strong>{dataPrimeiroVencimento}</strong></p>
                        <Select
                          styles={ValidSelect(errors.planoParcelado ? true : false)} // ou outro campo de erro
                          classNamePrefix="select"
                          isSearchable={false}
                          name="planoParcelado"
                          placeholder={t("label.select") + "..."}
                          options={drSimPlanosParceladosList}
                          value={drSimPlanoSelecionado}
                          getOptionLabel={(opcao) =>
                            `${opcao.numberOfInstallments}x de R$ ${transformValueFloattoFormated(opcao.amountPerInstallment)} (Total: R$ ${transformValueFloattoFormated(opcao.totalAmount)})`
                          }
                          getOptionValue={(opcao) => String(opcao.numberOfInstallments) + "-" + String(opcao.amountPerInstallment)}
                          onChange={handleSelecionaPlanoParcelado}
                          ref={() => register({ name: "planoParcelado" })}
                        />
                      </div>
                    </GridItem>

                    {drSimPlanoSelecionado && (
                      <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.container}>
                          <h3 className={classes.title}>Detalhes do Parcelamento</h3>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Valor da Parcela:</span>
                            <span className={classes.valor}>
                              R$ {transformValueFloattoFormated(drSimPlanoSelecionado.amountPerInstallment)}
                            </span>
                          </div>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Valor Total:</span>
                            <span className={classes.valor}>
                              R$ {transformValueFloattoFormated(drSimPlanoSelecionado.totalAmount)}
                            </span>
                          </div>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Número de Parcelas:</span>
                            <span className={classes.valor}>{drSimPlanoSelecionado.numberOfInstallments}</span>
                          </div>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Juros Efetivo Mensal:</span>
                            <span className={classes.valor}>
                              {transformValueFloattoFormated(drSimPlanoSelecionado.monthlyEffectiveInterestRate)}%
                            </span>
                          </div>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Juros Mensal:</span>
                            <span className={classes.valor}>
                              {transformValueFloattoFormated(drSimPlanoSelecionado.monthlyInterestRate)}%
                            </span>
                          </div>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Valor TAC:</span>
                            <span className={classes.valor}>
                              R$ {transformValueFloattoFormated(drSimPlanoSelecionado.tacAmount)}
                            </span>
                          </div>

                          <div className={classes.linha}>
                            <span className={classes.rotulo}>Valor IOF:</span>
                            <span className={classes.valor}>
                              R$ {transformValueFloattoFormated(drSimPlanoSelecionado.iofAmount)}
                            </span>
                          </div>
                        </div>
                      </GridItem>
                    )}

                    <GridItem xs={12} sm={12} md={12}>
                      <Button onClick={handleNovaSimulacao}>
                        {t('button.new_simulation')}
                      </Button>
                    </GridItem>
                  </GridContainer>
                  <hr className="lineGrayDashed" />
                  <GridContainer className={classes.containerin}>
                    <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'justify' }}>
                      <h3 className={classes.title}>
                        Ao clicar em “Continuar”, você confirma que o paciente concordou com os 
                        Termos de Uso e Política de Privacidade da Dr. Sim e autorizou o uso de seus 
                        dados com uma instituição parceira via SCR (Sistema de Informação de Crédito) 
                        para fins de análise de crédito.
                      </h3>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <RadioGroup 
                        value={confirmacaoAceite ? "sim" : ""} 
                        onChange={handleConfirmacaoAceite}>
                        <FormControlLabel
                          value="sim"
                          control={<Radio color="primary" />}
                          label="Continuar compartilhamento de dados com Dr Sim"
                        />
                      </RadioGroup>
                    </GridItem>
                  </GridContainer>
                  <hr className='lineGrayDashed' />
                </>
              )}

            </div>
          </>
        )}

        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={12} md={12}>
              {
                messageReturn.show &&
                //<div className="alertErrorEx alertmax">
                //<div className="alertEx alertmax">
                <div className={`alertmax ${messageReturn.tipo === 'erro' ? 'alertErrorEx' : 'alertEx'}`}>
                  <p>
                    {messageReturn.message}   
                  </p>
                </div>
              }
          </GridItem>
        </GridContainer>

        {
          botaoLancarPagamento &&
          (
            <GridContainer className={classes.containerin}>
              <GridItem xs={12} sm={12} md={12}>
                <center>
                  <Button type="submit" color="primary" >
                    {t('button.post_payment')}                      
                  </Button>
                </center>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <center>
                  {
                    LoadingForm && 
                    <CircularProgress />
                  }
                </center>
              </GridItem>
            </GridContainer>
          )
        }
      </form>
    
    </div>
  );
}